// Copyright © 2019-2026 Focal Systems. All rights reserved.

export const TASK_COLORS: Record<string, string> = {
  OOS: "#ff5a6a",
  LOW: "#d4a020",
  ZIN: "#28b8d4",
  MBL: "#be7aff",
  FLEX: "#3cb870",
  DELISTED: "#ff9ec4",
  PSI: "#5a6aff",
  FALSE_RESTOCK: "#99a5b0",
  POG_RESET: "#e56aaa",
  POG_COMPLIANCE: "#e05af5",
  TAG_COMPLIANCE: "#f5ad2b",
  SUSPICIOUS_STOCK: "#f55a5a",
  SCHEDULED_ROTATION: "#22c8db",
  RESTOCK: "#7a8999",
  FACE_OVER: "#8a857e",
  PRESENTABILITY: "#a8b0ba",
  Obstruction: "#ff7e68",
  Manual: "#7a8694",
};

const DISPLAY_NAMES: Record<string, string> = {
  FALSE_RESTOCK: "FALSE RESTOCK",
  POG_RESET: "POG RESET",
  POG_COMPLIANCE: "POG COMPLIANCE",
  TAG_COMPLIANCE: "TAG COMPLIANCE",
  SUSPICIOUS_STOCK: "SUSPICIOUS STOCK",
  SCHEDULED_ROTATION: "SCHEDULED ROTATION",
  FACE_OVER: "FACE OVER",
};

export function displayType(t: string): string {
  return DISPLAY_NAMES[t] || t.toUpperCase();
}
